import { ReactComponent as Home } from "../../components/svgs/home.svg";
import { ReactComponent as Aboutus } from "../../components/svgs/about-us.svg";
import { ReactComponent as Contactus } from "../../components/svgs/contact-us.svg";
import { ReactComponent as Logo } from "../../components/svgs/logo.svg";

export const SideBarLabels = {
  Logo: <Logo />,
  signupText: "Login/ Sign up",
  TnC1: "Terms & Condition ",
  TnC2: "Privacy Policy",
  botHead: "Any Questions?",
  botSubHead: "Any Questions??",
  botButton: "Chat here",
  switchButton:"Switch",
  switchSubHead:"Switch to OffsetGo Carburn",
  Tabs: [
    {
      id: "001",
      icon: <Home className="w-4 h-4" />,
      TabTitle: "Home",
      link: "/",
    },
    {
      id: "002",
      TabTitle: "About us",
      link: "/about-us",
      icon: <Aboutus className="w-4 h-4" />,
    },

    {
      id: "003",
      TabTitle: "Contact Us",
      link: "/contact-us",
      icon: <Contactus className="w-4 h-4" />,
    },
  ],
};
